module.exports = {
  "information": {},
}



// WEBPACK FOOTER //
// ./src/i18n/information/en.js